// extracted by mini-css-extract-plugin
export default {"gem":"yl_vW"};